import React from 'react';

import { Flex } from '@chakra-ui/react';

export const CardLeftElement = (props) => (
  <Flex flexDirection="column" align="flex-start" pr={4} {...props} />
);
